/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_GenerateInputs */

const en_landing_studio_generate = /** @type {(inputs: Landing_Studio_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate`)
};

const zh_landing_studio_generate = /** @type {(inputs: Landing_Studio_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生成`)
};

/**
* | output |
* | --- |
* | "Generate" |
*
* @param {Landing_Studio_GenerateInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_generate = /** @type {((inputs?: Landing_Studio_GenerateInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_GenerateInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_generate(inputs)
	return zh_landing_studio_generate(inputs)
});
export { landing_studio_generate as "landing.studio.generate" }